import React, { useState, useEffect } from 'react';
import './style.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import BotaoBusca from '../BotaoBusca.js';

function Header() {
  const [menuExpanded, setMenuExpanded] = useState(false);

  const toggleMenu = () => {
    setMenuExpanded(prev => !prev);
  };

  useEffect(() => {
    console.log('Header foi renderizado');
  }, []);

  return (
    <header className="header">
      <input
        type="checkbox"
        id="check"
        checked={menuExpanded}
        onChange={toggleMenu}
      />
      <label htmlFor="check" className="nav-icons">
        {menuExpanded ? <FaTimes id="close-icon" /> : <FaBars id="menu-icon" />}
      </label>

      <nav className={`menu-h ${menuExpanded ? 'expandir' : ''}`} id="menu-h">
        <Link to="/dashboard" className="dropdown voltar" onClick={() => setMenuExpanded(false)}>Home</Link>
        <Link to="/" className="dropdown estudante" onClick={() => setMenuExpanded(false)}>Histórico</Link>
        <Link to="/" className="dropdown unidade" onClick={() => setMenuExpanded(false)}>Acompanhamento</Link>
        <Link to="/" className="dropdown" onClick={() => setMenuExpanded(false)}>Sair</Link>
      </nav>
    </header>
  );
}

export default Header;
